import { Icon } from '@blueprintjs/core';
import classNames from 'classnames';
import { Button } from 'components/buttons';
import { FormHelperText } from "components/form-fields";
import { ShowHide } from "components/layout";
import { CheckCompletionStatsHelper } from 'pages/checks/templates/builder/preview/CheckCompletionStatsHelper';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from "react";

export function TemplateBuilderPreviewSection(
    {
        canDelete = false,
        onDelete = () => null,
        canRepeat = false,
        onRepeat = () => null,
        warningMessage = '',
        answersForSection,
        onClick,
        section
    }
) {
    const [percentageOfAnsweredComponent, setPercentageOfAnsweredComponent] = useState(0);
    const [isSectionComplete, setIsSectionComplete] = useState(false);

    useEffect(() => {
        const stats = CheckCompletionStatsHelper.getCompletionStatsForSection(section, answersForSection);

        if (stats.count) {
            setPercentageOfAnsweredComponent(Math.floor(stats.answeredCount * 100 / stats.count));
        } else {
            setPercentageOfAnsweredComponent(100);
        }
    }, [answersForSection]);

    useEffect(() => {
        setIsSectionComplete(percentageOfAnsweredComponent === 100);
    }, [percentageOfAnsweredComponent]);
  
    return (
        <div className={classNames("check-preview-section", "clickable")} onClick={onClick} onKeyDown={() => { }} role="tab" tabIndex={0}>
            <ShowHide
                evaluator={!!warningMessage}
                show={(
                    <div className="check-preview-section-metadata">
                        <span className="additional-data danger">{warningMessage}</span>
                    </div>)}
                />
                <div className='check-preview-section-title'>
                    <h4>{section.title}</h4>
                    <ShowHide
                        evaluator={canDelete}
                        show={<Button
                            icon='trash'
                            iconOnly={true}
                            minimal={true}
                            className='check-preview-section-delete'
                            onClick={(event) => event.stopPropagation() || onDelete()}
                        />}
                    />
                </div>

                <ShowHide
                    evaluator={!!section.helperText}
                    show={<FormHelperText>{section.helperText}</FormHelperText>}
                />
                <hr></hr>
                <div className="check-preview-section-footer">
                    <div className="check-preview-session-footer-text">
                        <Icon icon="tick" size={20} className={`tick-circle ${isSectionComplete ? 'tick-success' : ''}`} />
                        <span><span className="bold">{percentageOfAnsweredComponent}%</span> completed</span>
                    </div>
                </div>
                <ShowHide
                    evaluator={canRepeat}
                    show={<Button
                        onClick={(event) => event.stopPropagation() || onRepeat()}
                        className='check-preview-repeatable-button spacer-top'
                        text={"Add new section"}
                        icon="add"
                    />}
                />
            </div>
    );
}

TemplateBuilderPreviewSection.propTypes = {
    section: PropTypes.object.isRequired,
    answersForSection: PropTypes.array.isRequired,
    canDelete: PropTypes.bool,
    onDelete: PropTypes.func,
    canRepeat: PropTypes.bool,
    onRepeat: PropTypes.func,
    onClick: PropTypes.func.isRequired,
    warningMessage: PropTypes.string
};